import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";

export class OrderBillPaymentsBus extends BaseBus
{
    CID(): any {
        return this.orderBillPaymentId;
    }
    constructor(data: OrderBillPaymentsBus = null) {
        super(data);
    }
    initialize(data: OrderBillPaymentsBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.datePaid = CommonFunctions.getDate(data.datePaid);
        }
        catch {

        }

    }
    setId(id: any) {
        this.orderBillPaymentId = id;
    }
    setParentId(id: any) {
        this.orderBillId = id;
    }
    setFromForm(data: OrderBillPaymentsBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        if (this.hasId) {
            this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    orderBillPaymentId: any;
    orderBillId: any;
    datePaid: Date;
    paidById: any;
    amountPaid: number;
    qbid: string;
    qbeditSequenceId: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserid: any;
    ccaccountId: any;
    refNo: string;
    memo: string;
    released: boolean;
}
